import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "autofill-field-choices"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
import { computed } from "vue";
import { autofillConfidenceIcon } from "@/constants/autofill";
import { convertStateToFullName } from "@/utils/usaStates";
// Values autofill read from the documents for one form field, shown as chips under its input.
// The chip matching the input's current value is green; clicking another swaps it in.
export default /*@__PURE__*/ _defineComponent({
    __name: 'AutofillFieldChoices',
    props: {
        field: {},
        candidates: {},
        currentValue: {}
    },
    emits: ["apply"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const choices = computed(() => props.candidates ?? []);
        const current = computed(() => (props.currentValue == null ? "" : String(props.currentValue)));
        function isApplied(candidate) {
            // State chips are applied as full names ("CA" fills in "California"), so compare the converted value.
            if (props.field === "patientState" || props.field === "providerState") {
                return current.value !== "" && current.value === convertStateToFullName(String(candidate.value));
            }
            return current.value === String(candidate.value);
        }
        return (_ctx, _cache) => {
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _component_v_chip = _resolveComponent("v-chip");
            return (choices.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choices.value, (candidate) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                            key: candidate.value,
                            size: "small",
                            label: "",
                            color: isApplied(candidate) ? 'success' : 'primary',
                            variant: isApplied(candidate) ? 'flat' : 'outlined',
                            "prepend-icon": isApplied(candidate) ? 'mdi-check' : _unref(autofillConfidenceIcon)(candidate.confidence),
                            onClick: ($event) => (emit('apply', { field: props.field, value: candidate.value }))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(candidate.value) + " ", 1),
                                _createVNode(_component_v_tooltip, {
                                    activator: "parent",
                                    location: "top",
                                    "max-width": "400"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("strong", null, _toDisplayString(candidate.sourceDocument || "Uploaded document"), 1),
                                            (candidate.sourcePage)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " — page " + _toDisplayString(candidate.sourcePage), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (candidate.evidence)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "“" + _toDisplayString(candidate.evidence) + "”", 1))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", null, "Confidence: " + _toDisplayString(candidate.confidence), 1),
                                        (isApplied(candidate))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Applied to the form."))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1024)
                            ]),
                            _: 2
                        }, 1032, ["color", "variant", "prepend-icon", "onClick"]));
                    }), 128))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
